import { ComponentIds } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { ErrorMessages, ProductType, SlidingDoorComponent } from '@inter-ikea-storageone/range';
import { CornerSolutionComponent } from '@inter-ikea-storageone/range';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';
import { hidePaxCornerFrameOpenCombinationErrorMessageToast } from '../rules/hideMenuRules';

const dragAndDropDoorsBehavior = ({ coreApi, props, rootState }: BehaviorParameters) => {
  const doorAtPosition = coreApi.entities.getEntityAtPosition(props.position, [
    ComponentIds.DOOR_COMPONENT_ID,
    SlidingDoorComponent.id
  ]);
  if (doorAtPosition) {
    coreApi.entities.delete(doorAtPosition);
  }
  coreApi.toggleExhaustiveValidation(true);
  const placementResult = coreApi.products.addCluster(props.coreProductIds, props.position);

  if (!placementResult.valid) {
    const determinePlacementAttemptErrorMessage = () => {
      const cornerFramesInScene = coreApi.entities.getByComponent(CornerSolutionComponent.id);

      const products = rootState.products.inMarket;

      const product = products.find(product => product.coreProductId === props.coreProductId);

      const productIsSlidingDoor =
        product?.type === ProductType.PAX_SLIDING_DOOR_REGULAR_ASM ||
        product?.type === ProductType.PAX_SLIDING_DOOR_WITH_PANELS_ASM;

      // Check if product is TONSTAD w. glass doors, VIKANES or ÅHEIM
      const productIsNotValidForCornerSolution =
        product && product.meta?.allowOnCornerAddonFrame === false;

      if (!hideNoFramesInSceneErrorMessage(coreApi)) {
        return ErrorMessages.NoFramesInScene;
      } else if (cornerFramesInScene.length > 0 && productIsSlidingDoor) {
        return ErrorMessages.PaxSlidingDoorOnCorner;
      } else if (cornerFramesInScene.length > 0 && productIsNotValidForCornerSolution) {
        return ErrorMessages.PaxDoorAppliedButNotFittingCorner;
      } else if (!hidePaxCornerFrameOpenCombinationErrorMessageToast(coreApi)) {
        return ErrorMessages.PaxCornerFrameOpenCombination;
      }
      return null;
    };
    const placementAttemptErrorMessage = determinePlacementAttemptErrorMessage();
    if (placementAttemptErrorMessage) {
      coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
    }
    if (placementResult?.errors?.find(error => 'unfulfilledConnectors' in error)) {
      //If not possible to place new door undo potentiall delete of previous door
      coreApi.history.undo();
      coreApi.history.discardLatestSnapshot();
    } else {
      coreApi.createConflict(placementResult);
    }
  }
  coreApi.toggleExhaustiveValidation(false);
  return placementResult;
};

export default dragAndDropDoorsBehavior;
